// DTM
import React, { Component } from "react";
import styled from "styled-components";

import ArticleAbstract, { FlatBody } from "./ArticleAbstract";

import scale from "../helper/scaling";

const Wrapper = styled.div`
  width: 100%;
  float: left;
  padding-bottom: 65px;

  @media (max-width: 1100px) {
    padding-bottom: ${scale(1100, 767, 65, 30, "vw")};
  }
  @media (max-width: 700px) {
    width: 100%;
    padding: 40px 0 50px 0;
  }
`;
const Title = styled.div`
  padding: 30px calc(50% - 520px) 46px calc(50% - 520px);
  width: 1040px;
  float: left;

  font-family: Lato;
  font-size: 28px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.07;
  letter-spacing: 0.4px;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 1100px) {
    padding: ${scale(1100, 767, 30, 15, "vw")} 25px
      ${scale(1100, 767, 46, 18, "vw")} 25px;
    width: calc(100% - 50px);
    font-size: ${scale(1100, 767, 28, 24, "vw")};
  }
  @media (max-width: 700px) {
    font-size: 22px;
    line-height: 27px;
    letter-spacing: 0.3px;
    width: calc(100% - 46px);
    padding: 0 23px 40px 23px;
  }
`;
const Items = styled.div`
  float: left;
  width: 100%;

  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: stretch;

  position: relative;

  @media (max-width: 700px) {
    flex-direction: column;
    padding: 0 23px;
    width: calc(100% - 46px);
  }
`;
const LineContainer = styled.div`
  width: 100%;
  height: 147px;

  position: absolute;
  left: 0;
  top: calc(50% - 75px);

  svg {
    width: 100%;
    height: 100%;
  }

  @media (max-width: 1100px) {
    height: 120px;
    top: calc(50% - 60px);
  }
  @media (max-width: 700px) {
    display: none;
    width: 0;
    height: 0;
    top: 0;
    overflow: hidden;
  }
`;
const MobileLineContainer = styled.div`
  display: none;
  width: 0;
  height: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;

  svg {
    width: 100%;
    height: 100%;
  }
  @media (max-width: 700px) {
    display: block;
    width: 100%;
    height: 100%;

    height: calc(100% - 120px);
    top: 70px;
  }
`;

class SetOneTwoThree extends Component {
  render() {
    let first = this.props.set[0];
    let items = [];
    for (let i in this.props.set) {
      if (i > 0) items.push(this.props.set[i]);
    }
    return (
      <Wrapper>
        <Title>{first.title}</Title>
        <Items>
          <LineContainer>
            <Line />
          </LineContainer>
          <MobileLineContainer>
            <MobileLine />
          </MobileLineContainer>
          {items.map((item, index) => (
            <OneTwoThree no={index + 1} content={item} />
          ))}
        </Items>
      </Wrapper>
    );
  }
}

export default SetOneTwoThree;

const Item = styled.div`
  width: 310px;
  margin: 17px;
  position: relative;

  background-color: #f9f9f9;

  @media (max-width: 1100px) {
    width: calc(33% - 53px);
  }
  @media (max-width: 700px) {
    width: 100%;
    float: left;
    margin: 33px 0 0 0;
  }
`;
const ItemNumber = styled.div`
  position: absolute;
  left: 15px;
  top: -17px;
  height: 35.4px;
  svg {
    height: 35.4px;
  }

  @media (max-width: 1100px) {
    height: ${scale(1100, 767, 35.4, 30, "vw")};
    svg {
      height: ${scale(1100, 767, 35.4, 30, "vw")};
    }
  }
  @media (max-width: 700px) {
    height: 35px;
    svg {
      height: 35px;
    }
  }
`;
const ItemTitle = styled.div`
  width: 100%;
  float: left;
  font-family: Lato;
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 3.22;
  letter-spacing: 0.3px;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 18, 16, "vw")};
  }
  @media (max-width: 700px) {
    font-size: 16px;
    line-height: 27px;
    letter-spacing: 0.2px;
  }
`;
const ItemBody = styled.div`
  width: calc(100% - 30px);
  float: left;
  padding: 19px 15px 33px 15px;

  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 1100px) {
    padding: ${scale(1100, 767, 19, 5, "vw")} 12px
      ${scale(1100, 767, 33, 15, "vw")} 12px;

    font-size: ${scale(1100, 767, 14, 12, "vw")};
  }
  @media (max-width: 700px) {
    padding: 12px 16px 25px 16px;
    width: calc(100% - 32px);
    font-size: 12px;
    line-height: 1.5;
  }
`;

class OneTwoThree extends ArticleAbstract {
  render() {
    return (
      <Item {...this.link()}>
        <ItemNumber>
          <Digit no={this.props.no} />
        </ItemNumber>
        <ItemTitle>{this.title()}</ItemTitle>
        <ItemBody>
          <FlatBody>{this.body()}</FlatBody>
        </ItemBody>
      </Item>
    );
  }
}

class Digit extends Component {
  render() {
    if (this.props.no) {
      switch (this.props.no) {
        case 1:
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="36"
              viewBox="0 0 23 36"
            >
              <path
                fill="#3949AB"
                fillRule="evenodd"
                d="M14.46 6.41H7.307l.513-2.1h2.685c1.156 0 2.226-.134 3.21-.402a12.821 12.821 0 0 0 2.723-1.075c.83-.447 1.839-1.175 3.027-2.185h3.15c-.586 1.954-1.237 4.452-1.954 7.496l-5.249 22.802-.146 1.001c0 .7.44 1.233 1.318 1.6.88.366 2.54.614 4.98.744L21.175 36H.471l.39-1.709c2.719-.049 4.635-.31 5.75-.781 1.115-.472 1.786-1.213 2.014-2.222L14.46 6.41z"
              />
            </svg>
          );
        case 2:
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="36"
              viewBox="0 0 30 36"
            >
              <path
                fill="#3949AB"
                fillRule="evenodd"
                d="M18.316.697c3.45 0 6.136.773 8.056 2.32 1.92 1.546 2.881 3.654 2.881 6.323 0 1.79-.305 3.312-.915 4.565-.61 1.254-1.595 2.434-2.954 3.54-1.36 1.107-3.601 2.458-6.726 4.053-4.15 2.165-7.17 3.874-9.058 5.127-1.888 1.253-3.15 2.409-3.784 3.467h20.703L25.054 36H.224l.88-4.59c1.155-1.497 2.604-2.966 4.345-4.407 1.742-1.44 4.297-3.259 7.667-5.456 2.555-1.644 4.41-3.052 5.566-4.224 1.156-1.172 2.006-2.42 2.551-3.747.545-1.327.818-2.869.818-4.627 0-2.018-.423-3.548-1.27-4.59-.846-1.041-2.001-1.562-3.466-1.562-1.058 0-1.978.146-2.76.44-.78.292-1.39.65-1.83 1.074.358 1.383.537 2.514.537 3.393 0 1.384-.362 2.413-1.086 3.088-.725.676-1.68 1.014-2.87 1.014-.927 0-1.692-.277-2.294-.83-.602-.554-.903-1.31-.903-2.27 0-1.368.557-2.674 1.672-3.92 1.115-1.244 2.625-2.237 4.529-2.978a16.424 16.424 0 0 1 6.006-1.11z"
              />
            </svg>
          );
        case 3:
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="29"
              height="37"
              viewBox="0 0 29 37"
            >
              <path
                fill="#3949AB"
                fillRule="evenodd"
                d="M28.766 7.753c0 2.197-.883 4.146-2.649 5.847-1.766 1.701-4.17 2.901-7.214 3.601l-.147.39c2.409.131 4.321.806 5.737 2.027 1.416 1.22 2.124 2.816 2.124 4.785 0 2.295-.72 4.383-2.16 6.263-1.44 1.88-3.43 3.356-5.97 4.43-2.538 1.075-5.281 1.612-8.227 1.612-3.076 0-5.546-.639-7.41-1.916C.987 33.514.055 31.833.055 29.75c0-1.123.338-2.039 1.013-2.747.676-.708 1.575-1.062 2.698-1.062 1.009 0 1.835.277 2.478.83.643.554.964 1.278.964 2.173 0 .847-.285 1.953-.854 3.32l-.39.928a5.676 5.676 0 0 0 2.062 1.136c.74.22 1.567.33 2.478.33 1.546 0 2.999-.457 4.358-1.368 1.36-.911 2.441-2.201 3.247-3.87.806-1.668 1.209-3.56 1.209-5.676 0-3.027-1.766-4.54-5.298-4.54h-3.198l.634-2.808h2.149c2.441 0 4.386-.826 5.835-2.479 1.448-1.652 2.173-3.877 2.173-6.677 0-2.962-1.465-4.443-4.395-4.443-1.66 0-3.23.537-4.712 1.611.098.44.216.924.354 1.453.138.529.208 1.11.208 1.745 0 1.351-.358 2.389-1.075 3.113-.716.725-1.725 1.087-3.027 1.087-.911 0-1.648-.273-2.21-.818-.56-.545-.842-1.306-.842-2.283 0-1.286.582-2.555 1.746-3.809 1.164-1.253 2.747-2.266 4.748-3.04 2.002-.772 4.15-1.159 6.446-1.159 2.197 0 4.02.297 5.469.891 1.448.594 2.55 1.416 3.308 2.466.756 1.05 1.135 2.283 1.135 3.699z"
              />
            </svg>
          );
        default:
          return (
            <div style={{ color: "red" }}>
              One too many -- did you forget to split a set?
            </div>
          );
      }
    } else {
      return <div />;
    }
  }
}

class Line extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1320"
        height="151"
        preserveAspectRatio="none"
        viewBox="0 0 1320 151"
      >
        <path
          fill="none"
          fillRule="evenodd"
          stroke="#3949AB"
          strokeWidth="3"
          d="M0 37.157c78.898-27.28 325.86-85.178 689.562 56.13 363.702 141.306 594-27.911 631.438-51.657"
        />
      </svg>
    );
  }
}

class MobileLine extends Component {
  render() {
    return (
      <svg
        width="320px"
        height="511px"
        viewBox="0 0 320 511"
        preserveAspectRatio="none"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Smartphone-Components"
            transform="translate(0.000000, -1041.000000)"
            stroke="#3949AB"
            strokeWidth="3"
          >
            <path
              d="M-49,1017 C-21.287078,1021.66181 65.4578742,1063.76576 193.207956,1352.53202 C320.958037,1641.29829 401.849864,1565.24197 415,1556.64346"
              id="full-line-blue"
            />
          </g>
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SetOneTwoThree.js